import React from 'react';
import { Text } from '../../../components/Text';
import { Tooltip } from '../../../components/Tooltip';
import { identifyComponent } from '../../../util';
import css from './index.module.scss';

interface TableHeadCellLabelProps extends Partial<React.ComponentProps<typeof Text>> {
  children?: React.ComponentProps<typeof Text>['children'];
  tooltip?: React.ComponentProps<typeof Tooltip>['tooltipContent'];
  tooltipProps?: Partial<Omit<React.ComponentProps<typeof Tooltip>, 'tooltipContent' | 'compact'>>;
}

export const TableHeadCellLabel: React.FunctionComponent<TableHeadCellLabelProps> = ({
  children,
  tooltip,
  tooltipProps = {},
  ...rest
}) => {
  const identityProps = identifyComponent('table-head-cell-label', rest);
  const content = tooltip ? (
    <Text appearance="bodySmallBold" tag="span" {...rest} {...identityProps}>
      <span className={css.dashed}>{children}</span>
    </Text>
  ) : (
    <Text appearance="bodySmallBold" tag="span" {...rest} {...identityProps}>
      {children}
    </Text>
  );

  return tooltip ? (
    <div data-component="TableHeadCellLabel" style={{ display: 'inline-block' }}>
      <Tooltip tooltipContent={tooltip} variant="dark" {...tooltipProps}>
        {content}
      </Tooltip>
    </div>
  ) : (
    content
  );
};
